import React from "react";
import StepLg from "./StepLg";
import StepSm from "./StepSm";
import "./styles.scss";

const Steps = ({ steps = [] }) => {
  return (
    <React.Fragment>
      <div className='container__steps d-none d-lg-flex flex-row justify-content-center'>
        {steps.map((step, key) => (
          <StepLg {...step} key={key} />
        ))}
      </div>
      <ul className='list-unstyled ml-4 d-flex flex-column d-lg-none pb-5'>
        {steps.map((step, key) => (
          <StepSm {...step} key={key} />
        ))}
      </ul>
    </React.Fragment>
  );
};

export default Steps;
